import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    [
      face.r.one,
      face.u.one,
      face.r.pri,
      face.u.one,
    ],
    [
      face.r.one,
      face.u.two,
      face.r.pri,
    ],
  ],
  name: 'Sune',
};
